import React from 'react';

export function StepNewProductionSiteLabel() {
  return (
    <>
      Nové průmyslové místo - <b>Editace údajů</b>
    </>
  );
}
